import React, { Component } from 'react';
import { connect } from 'react-redux'
import _close from "./images/close.png"
import point from "./images/point.png"
import comment from "./images/comment.png"
import history from './history'
import './PostGrid.css'
import { deletePost, interactPost } from "./actions/posts";
import {formatContent} from "./utils";

class PostGrid extends Component {
  state = {hidden: false}
  render() {
    const self = this
    const {post, close, del, style} = this.props
    return <div
      className={"post-grid-container"}
      style={{
        ...style,
        display: self.state.hidden?'none': 'block'
      }}
      onClick ={()=>{
        if(post && post._id){
          this.props.interactPost(post._id)
          history.push('/posts/'+post._id)
        }
      }}
    >
      <div
        className={"post-grid-header"}
        onClick={(e)=>{
          if(window.location.pathname !== '/users/'+post.user._id){
            e.preventDefault()
            e.stopPropagation()
            history.push('/users/'+post.user._id)
          }
        }}
      >
        <span className={"post-grid-head-image"} style={{
          backgroundImage: !post.anonymous && `url(${post.user.headImgUrl})`
        }} />
        <span className={"post-grid-nickname"}>
              {post.anonymous?'匿名':post.user.nickname}
        </span>
      </div>
      <div className={"post-grid-content"}>
        {formatContent(post.content)}
      </div>
      <div className={"post-grid-footer"}>
            <span className={"post-grid-point"} style={{
              backgroundImage: `url(${point})`
            }}>{post.rewards || 0}</span>
        <span className={"post-grid-comment"} style={{
          backgroundImage: `url(${comment})`
        }}>{post.commentsCount || 0}</span>
      </div>
      {
        del && <div className={"post-grid-close"} style={{
          backgroundImage: `url(${_close})`
        }} onClick={(e)=>{
          e.preventDefault()
          e.stopPropagation()
          self.props.deletePost(post._id)
        }}>
        </div>
      }
      {
        close &&
        <div className={"post-grid-close"} style={{
          backgroundImage: `url(${_close})`
        }} onClick={(e)=>{
          e.preventDefault()
          e.stopPropagation()
          self.setState({hidden: true})
        }}>
        </div>
      }
    </div>
  }

}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    deletePost: (id)=>dispatch(deletePost(id)),
    interactPost: (id)=>dispatch(interactPost(id))
  }
}

export default connect(
  null,
  mapDispatchToProps
)(PostGrid)





// WEBPACK FOOTER //
// ./src/PostGrid.js